import { FormControl } from '@angular/forms';
import { CustomValidators } from 'src/modules/shared/validators/custom.validators';
import { WordDataTypeEnum } from '../models/enums/word-data-type.enum';
import { IFileProcessedWord } from '../models/interfaces/files.interface';
import { IBarcode } from '../models/interfaces/barcode.interface';

export class ExtractorsUtility {
  // (accepts: xxx,xx | xxx, xx | xxx , xx)
  public static tryParseCurrency(text: string, force = false): IFileProcessedWord {
    let value: string[];

    if (force === true) {
      value = [text.replace(/\D/g, '')];
    } else {
      value = text.match(/(\b)(?:(?:[1-9]\d{0,5}(?:(?:\,|\.)\d{3})*|0)\ ?(?:\,|\.)\ ?\d{2})(?= |\t|\n|\r|$)/g);
    }

    if (value && value[0]) {
      value[0] = value[0].replace(/\./g, '');
      value[0] = value[0].replace(',', '');
      value[0] = value[0].replace(/\ /g, '');

      if (parseInt(value[0], 10) !== 0) {
        return {
          index: 0,
          originalValue: value[0],
          value: parseInt(value[0], 10) / 100,
          valueType: WordDataTypeEnum.currency,
        };
      }
    }

    return null;
  }

  // (accepts: xx/xx/xxx | xx/xx/xx | xx-xx-xxxx)
  public static tryParseDate(text: string): IFileProcessedWord {
    if (text) {
      const value = text.match(/([0-2][0-9]|(3)[0-1])(\/|-)(((0)[0-9])|((1)[0-2]))(\/|-)(\d{4}|\d{2})/g);
      if (value && value[0]) {
        value[0].replace(/\ /g, '');
        const split = value[0].indexOf('-') === -1 ? value[0].split('/') : value[0].split('-');
        if (split.length === 3) {
          return {
            index: 0,
            originalValue: value[0],
            value: (split[2].length === 2 ? '20' + split[2] : split[2]) + '-' + split[1] + '-' + split[0],
            valueType: WordDataTypeEnum.dateTime,
          };
        }
      }
    }

    return null;
  }

  public static tryParseEntityName(text: string): IFileProcessedWord {
    const value = text.match(
      /(?<=cliente:|beneficiário:|convênio:|funcionário:|nome:|favorecido|razão social|nome fantasia:|nome fantasia|cooperado:|nome do destinatário:|Concessionária:|orgão:|nome:|empresa:|nome do recebedor:).*/gi
    );
    if (value && value[0]) {
      value[0] = value[0].toLowerCase().replace(/\:/g, '').trim();
      return {
        index: 0,
        value: value[0].toUpperCase(),
        originalValue: value[0],
        valueType: WordDataTypeEnum.entity,
      };
    } else {
      return null;
    }
  }

  // (accepts: xxxxxxxxxxxxxx | xx.xxx.xxx/xxxx-xx | xx xxx xxx/xxx-xx | xx,xxx.xxx/xxxx-xx)
  public static tryParseCNPJ(text: string): IFileProcessedWord {
    const value = text.match(/(\b)[0-9]{2,3}\ ?(?:\.|\,)?\ ?[0-9]{3}\ ?(?:\.|\,)?\ ?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}(?= |\t|\n|\r|$)/gi);
    if (value && value[0]) {
      // Check if has zero left
      if (value[0].split('.')[0].length === 3 && value[0][0] === '0') {
        value[0] = value[0].substring(1);
      }
      const formVal = new FormControl();
      formVal.setValue(value[0]);
      if (CustomValidators.CNPJValidator(formVal) === null) {
        return {
          index: 0,
          value: value[0].replace(/\D/g, ''),
          originalValue: value[0],
          valueType: WordDataTypeEnum.cnpj,
        };
      }
    }

    return null;
  }

  // (accepts: xxxxxxxxxxx | xxx.xxx.xxx-xx)
  public static tryParseCPF(text: string): IFileProcessedWord {
    const value = text.match(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/gi);
    if (value && value[0]) {
      const formVal = new FormControl();
      formVal.setValue(value[0]);
      if (CustomValidators.CPFValidator(formVal) === null) {
        return {
          index: 0,
          value: value[0].replace(/\D/g, ''),
          originalValue: value[0],
          valueType: WordDataTypeEnum.cpf,
        };
      }
    }

    return null;
  }

  // (accepts: xxxx.xxxx xxxxx.xxxxxx xxxxx.xxxxxx x xxxxxxxxxxxxxx)
  public static tryParseBoletoBarcode(text: string): IFileProcessedWord {
    const value = text.replace(/\D/g, '');
    const match = value.match(/(\d{47})/g);

    if (match && match[0]) {
      return {
        index: 0,
        value: ExtractorsUtility.tryExtractBarcodeData(value),
        originalValue: text,
        valueType: WordDataTypeEnum.barcode,
      };
    }

    return null;
  }

  /**
   * Extrai do código de barras de boletos bancários o valor e data de vencimento do boleto
   */
  public static tryExtractBarcodeData(barcode: string): IBarcode {
    const boletoInfo: IBarcode = { barcode };

    boletoInfo.amount = parseInt(barcode.substr(37, 10)) / 100;
    const dueDateDays = parseInt(barcode.substr(33, 4));
    const dueDate = new Date(1997, 9, 7);
    dueDate.setDate(dueDate.getDate() + dueDateDays);

    boletoInfo.dueDate = dueDate;

    return boletoInfo;
  }
}
